import $ from "jquery";
import mainNav from "./components/mainNav";
import global from "./components/global";
import Headroom from "headroom.js"; 
import simpleLightbox from "simple-lightbox";

import Contact from "./components/contactForm";
import ContactFull from "./components/contactForm-full";


function loaded(){
    global();
    mainNav();
    Contact();
    ContactFull();

// grab an element
var header = document.querySelector("#main_head");
// construct an instance of Headroom, passing the element
var headroom  = new Headroom(header);
// initialise
headroom.init();
$('.piece__gallery .piece__image').simpleLightbox();
};


window.addEventListener('DOMContentLoaded', (event) => {
    loaded();
});
